import { $qs, $qsa } from '../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);



function houses() {
    const section = $qs('[data-name="houses"]');
    const sidebar = $qs('[data-target="houses-sidebar"]');
    const sidebarHouses = $qsa('[data-target="sidebar-house"]');
    const houses = $qsa('[data-target="house"]');

    // pin sidebar
    ScrollTrigger.create({
        trigger: section,
        pin: sidebar,
        pinSpacing: false,
        start: 'top 10%',
        end: 'bottom center',
    });

    // change bg colour and active sidebar item when entering each step
    houses && [...houses].forEach(house => {

        const { id } = house.dataset;

        ScrollTrigger.create({
            trigger: house,
            pin: false,
            scrub: false,
            start: 'top center',
            end: 'bottom center',
            onEnter: () => {
                [...sidebarHouses].forEach(sidebarHouse => sidebarHouse.dataset.active = 'false');
                $qs(`[data-target="sidebar-house"][data-id="${id}"]`, sidebar).dataset.active = 'true';

            },
            onEnterBack: () => {
                [...sidebarHouses].forEach(sidebarHouse => sidebarHouse.dataset.active = 'false');
                $qs(`[data-target="sidebar-house"][data-id="${id}"]`, sidebar).dataset.active = 'true';
            },
            // markers: true
        })
    });
}

function scrollingText() {
    const section = $qs('[data-name="scrolling-text"]');
    const scrollingTextContainer = $qs('[data-target="scrolling-text-container"]', section);
    const scrollingTextWrappers = $qsa('[data-target="scrolling-text"]', section);
    const horizontalPadding = 16;

    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: scrollingTextContainer,
            scrub: true,
            start: 0,
            end: 'bottom top',
            // markers: true
        }
    });

    timeline.addLabel('start');

    [...scrollingTextWrappers].forEach((wrapper, index) => {
        const width = wrapper.offsetWidth;

        if (index === 0) {
            timeline.fromTo(wrapper, {
                x: `${horizontalPadding}px`,
                ease: 'none'
            }, {
                x: `-${width - section.offsetWidth + horizontalPadding}`,
                ease: 'none'
            }, 'start');
        } else {
            timeline.fromTo(wrapper, {
                x: `-${width - section.offsetWidth + horizontalPadding}`,
                ease: 'none'
            }, {
                x: `${horizontalPadding}px`,
                ease: 'none'
            }, 'start');
        }
    });
}

function Houses() {
    if (!$qs('.page-template-tpl-houses')) return;
    
    houses();
    scrollingText();
}

export default Houses;